module.exports = " <div class=\"\" _v-11e94be5=\"\"> Nouveau Groupe </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-11e94be5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewGroup.vue
// module id = 316
// module chunks = 2